/**
 * Standard Mode Strategy
 *
 * Display mode strategy for the default centered popup.
 * This is the classic popup that appears centered on screen with a backdrop.
 */

import type { DisplayConfig } from '../../shared/types/popup';
import { BaseDisplayModeStrategy } from './base-strategy';

/**
 * Strategy for standard centered popup display mode.
 */
export class StandardModeStrategy extends BaseDisplayModeStrategy {
	/**
	 * Returns CSS classes for standard popup mode.
	 */
	public getDisplayModeClasses = (): string[] => {
		return ['gp-popup--popup'];
	};

	/**
	 * Apply custom sizing to the dialog.
	 * Standard popups support width/height customization.
	 */
	public applyDialogSizing = (
		dialog: HTMLElement,
		config: DisplayConfig
	): void => {
		dialog.style.width = config.popupWidth;
		dialog.style.height = config.popupHeight;
	};

	/**
	 * Standard popups respect the closeOnBackdropClick config.
	 */
	public shouldCloseOnBackdropClick = (config: DisplayConfig): boolean => {
		return config.closeOnBackdropClick;
	};
}
